import { ChartFilter } from './chart-filter';

export class ChartFilterGroup {
    filters: ChartFilter[];

    /* The chart label for the group. */
    label: string;
}
